module.exports = __webpack_public_path__ + "static/media/inREALTIME_vs.e187b88d.mp4";